import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import "./App.css";
import Nav from "./components/Nav";
import Footer from "./components/Footer";
import SmoothScroll from "./components/SmoothScroll";
import { Toaster } from "@/components/ui/sonner";
import Home from "./pages/Home";
import About from "./pages/About";
import Books from "./pages/Books";
import Parents from "./pages/Parents";
import Waitlist from "./pages/Waitlist";
import Admin from "./pages/Admin";

function ScrollTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [pathname]);
  return null;
}

function Shell() {
  const { pathname } = useLocation();
  const hideChrome = pathname.startsWith("/admin");
  return (
    <>
      {!hideChrome && <Nav />}
      <main data-testid="app-main" className="grain">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/charlie" element={<About />} />
          <Route path="/books" element={<Books />} />
          <Route path="/parents" element={<Parents />} />
          <Route path="/waitlist" element={<Waitlist />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </main>
      {!hideChrome && <Footer />}
    </>
  );
}

function App() {
  return (
    <div className="App">
      <SmoothScroll />
      <BrowserRouter>
        <ScrollTop />
        <Shell />
      </BrowserRouter>
      <Toaster
        position="bottom-center"
        toastOptions={{
          classNames: {
            toast: "bg-[#2C241B] text-[#FAF8F5] border-none",
          },
        }}
      />
    </div>
  );
}

export default App;
